import { render } from "./PostMetaComponent.vue?vue&type=template&id=0a6d4e16&ts=true"
import script from "./PostMetaComponent.vue?vue&type=script&lang=ts"
export * from "./PostMetaComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__